<button
  *ngIf="options.closeButton"
  (click)="remove()"
  class="toast-close-button"
  aria-label="Close"
>
  <span aria-hidden="true">&times;</span>
</button>
<div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">{{ title }}</div>

<div class="content" [ngSwitch]="scope.type">
  <div *ngSwitchCase="'onAgentBuildSuccess'">
    <span>Agent <a class="link">{{scope.alias}}</a> has been created. </span>
  </div>
  <div *ngSwitchCase="'onMonitorCreationSuccess'">
    <p>Active test <a class="link" (click)="scope.onClick()">{{scope.alias}}</a> created</p>
    <a (click)="scope.onClick()" class="button">VIEW DASHBOARD</a>
  </div>
  <div *ngSwitchCase="'onMonitorBulkCreationSuccess'">
    <p>
      Your tests have been created. You can view them in the
      <a class="link" (click)="scope.onClick()">{{scope.alias}}</a>
    </p>
  </div>
  <div *ngSwitchCase="'onMonitorBulkCreationFailed'">
    <p>
      Some of your test could not be created.
      <a class="link" (click)="scope.onClick()">{{scope.alias}}</a>
      to view details
    </p>
  </div>
  <div *ngSwitchCase="'onMonitorUpdatingSuccess'">
    <p>
      Active test <a class="link">{{scope.alias}}</a> has been updated. Changes should take affect
      in a couple of minutes.
    </p>
  </div>
  <div *ngSwitchCase="'onHWAgentBuildSuccess'">
    <span>Agent <a class="link">{{scope.alias}}</a> has been claimed.</span>
  </div>
  <div *ngSwitchCase="'onAgentRegistered'">
    <p>Agent <a class="link" (click)="scope.onClick()">{{scope.alias}}</a> is now registered.</p>
    <a class="button" (click)="scope.onAddMonitorClick()">ADD MONITOR</a>
  </div>
  <div *ngSwitchCase="'onAgentOnline'">
    <p>Agent <a class="link" (click)="scope.onClick()">{{scope.alias}}</a> is online.</p>
    <a (click)="scope.onClick()" class="button">VIEW AGENT DETAILS</a>
  </div>
  <div *ngSwitchCase="'onAgentOffline'">
    <p>Agent <a class="link" (click)="scope.onClick()">{{scope.alias}}</a> is offline.</p>
    <a (click)="scope.onClick()" class="button">VIEW AGENT DETAILS</a>
  </div>
  <div *ngSwitchCase="'onAlert'">
    <p>{{scope.description}}</p>
    <a (click)="scope.onClick()" class="button">VIEW</a>
  </div>
  <div *ngSwitchCase="'onNotificationCount'">
    <p>You have {{scope.count}} notifications!</p>
    <a (click)="scope.onClick()" class="button">View notifications</a>
  </div>
  <div *ngSwitchCase="'onAlertCount'">
    <p>You have {{scope.count}} alerts!</p>
    <a (click)="scope.onClick()" class="button">View alerts</a>
  </div>
  <div class="onChipDeleted" *ngSwitchCase="'onChipDeleted'">
    <span>Chip deleted.</span><span class="link" (click)="scope.onClick()"> Undo</span>
  </div>
  <div *ngSwitchDefault>
    <div *ngIf="options.enableHtml" [innerHTML]="message"></div>
    <div *ngIf="!options.enableHtml">{{message}}</div>
  </div>
</div>

<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
